class Geolocator {
  constructor() {
    this.refs = {
      html: 'html',
      price: '.js-geolocation-price',
      addToCart: '.js-geolocation-add-to-cart',
      addToCartAlternate: '.js-geolocation-add-to-cart-alternate',
      cart: '.js-geolocation-cart',
      locationBasedPopup: '.js-location-based-popup'

    }
    this.dom = {
      $html: document.querySelector(this.refs.html),
      $prices: document.querySelectorAll(this.refs.price),
      $addToCartBtns: document.querySelectorAll(this.refs.addToCart),
      $addToCartAlternate: document.querySelector(this.refs.addToCartAlternate),
      $cart: document.querySelector(this.refs.cart),
      $locationBasedPopup: document.querySelector(this.refs.locationBasedPopup)
    }
    this.state = {
      cookieName: 'geolocation',
      accessKey: '21b46f002fcdd60014f109bdfd39e24d',
      requestUrl: 'http://api.ipstack.com/check?access_key=',
      countryCode: null,
      locationBasedPopupCookie: 'locationbasedpopup',
      validCountryCodes: [
        "AG", // Antigua & Barbuda
        "AI", // Anguilla
        "AR", // Argentina
        "AS", // American Samoa
        "AW", // Aruba
        "BB", // Barbados
        "BL", // St. Barthélemy
        "BM", // Bermuda
        "BO", // Bolivia
        "BQ", // Caribbean Netherlands
        "BR", // Brazil
        "BS", // Bahamas
        "BZ", // Belize
        "CA", // Canada
        "CL", // Chile
        "CO", // Colombia
        "CR", // Costa Rica
        "CW", // Curaçao
        "DM", // Dominica
        "DO", // Dominican Republic
        "EC", // Ecuador
        "FK", // Falkland Islands
        "FM", // Federated States of Micronesia
        "GF", // French Guiana
        "GL", // Greenland
        "GP", // Guadeloupe
        "GT", // Guatemala
        "GU", // Guam
        "GY", // Guyana
        "HN", // Honduras
        "HT", // Haiti
        "JM", // Jamaica
        "KN", // St. Kitts & Nevis
        "KY", // Cayman Islands
        "LC", // St. Lucia
        "MF", // St. Martin
        "MH", // Marshall Islands
        "MP", // Northern Mariana Islands
        "MS", // Montserrat
        "MQ", // Martinique
        "MX", // Mexico
        "NI", // Nicaragua
        "PA", // Panama
        "PE", // Peru
        "PM", // St. Pierre & Miquelon
        "PR", // Puerto Rico
        "PW", // Palau
        "PY", // Paraguay
        "SR", // Suriname
        "SX", // Sint Maarten
        "TC", // Turks & Caicos Islands
        "TT", // Trinidad & Tobago
        "US", // United States
        "UY", // Uruguay
        "VE", // Venezuela
        "VC", // St. Vincent & Grenadines
        "VG", // British Virgin Islands
        "VI", // U.S. Virgin Islands
        "GS"  // South Georgia & South Sandwich Islands
      ]
    }

    this.init();
  }

  async init() {
    const { state } = this;
    let cookie = this.getCookie(state.cookieName) ? this.getCookie(state.cookieName) : false;
    if (!cookie) {
      await this.getLocationViaIp();
    } else {
      this.setState(cookie)
    }

    this.updateDomElementsBasedOnLocation();
  }

  updateDomElementsBasedOnLocation() {
    const { state } = this;
    const isValidCountryCode = state.validCountryCodes.includes(state.countryCode);
    if (!isValidCountryCode) {
      this.showAlternateAddToCartButton();
      this.showLocationBasedPopup();
    } else {
      this.showCart();
      this.showPrices();
      this.showAddToCartButton();
      setInterval(this.showPrices.bind(this), 500)
    }
  }

  showLocationBasedPopup() {
    const { dom, state } = this;
    if (!dom.$locationBasedPopup) return;

    const hasShownPopup = this.getCookie(state.locationBasedPopupCookie)

    if (hasShownPopup === "true") return;

    dom.$locationBasedPopup.classList.add('is-active');
  }

  showCart() {
    const { dom } = this;
    if (!dom.$cart) return;

    dom.$cart.removeAttribute('hidden');
  }

  showAlternateAddToCartButton() {
    const { dom } = this;
    if (!dom.$addToCartAlternate) return;

    dom.$addToCartAlternate.removeAttribute('hidden');
  }

  showAddToCartButton() {
    const { dom, refs } = this;
    if (dom.$addToCartBtns.length) {
      dom.$addToCartBtns.forEach($addToCartBtn => {
        $addToCartBtn.removeAttribute('hidden');
        $addToCartBtn.classList.remove(refs.addToCart.replace('.', ''))
      })
    }
  }

  showPrices() {
    const { dom, refs } = this;
    dom.$prices = document.querySelectorAll(refs.price)
    if (dom.$prices.length) {
      dom.$prices.forEach($price => {
        $price.removeAttribute('hidden');
        $price.classList.remove(refs.price.replace('.', ''))
      })
    }
  }

  async getLocationViaIp() {
    const { state } = this;
    const response = await fetch(state.requestUrl + state.accessKey);
    const data = await response.json();
    if (data.country_code) {
      this.setState(data.country_code);
      this.setCookie('geolocation', data.country_code, 30);
    } else {
      this.setState("US");
      this.setCookie('geolocation', "US", 30);
    }
  }

  setState(countryCode) {
    const { state } = this;
    state.countryCode = countryCode;
  }

  setCookie(cName, cValue, expDays) {
    let date = new Date();
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
  }

  getCookie(cName) {
    const name = cName + "=";
    const cDecoded = decodeURIComponent(document.cookie); //to be careful
    const cArr = cDecoded .split('; ');
    let res;
    cArr.forEach(val => {
        if (val.indexOf(name) === 0) res = val.substring(name.length);
    })
    return res;
  }
}

class LocationBasedPopup {
  constructor() {
    this.refs = {
      component: '.js-location-based-popup',
      close: '.js-close'
    }
    this.dom = {
      $component: document.querySelector(this.refs.component),
      $closeEls: document.querySelectorAll(this.refs.close)
    }
    this.state = {
      cookieName: 'locationbasedpopup'
    }

    this.mount();
  }

  mount() {
    const { dom } = this;
    dom.$closeEls.forEach($close => {
      $close.addEventListener('click', this.close.bind(this))
    })
  }

  close() {
    const { dom, state } = this;
    dom.$component.classList.remove('is-active');
    this.setCookie(state.cookieName, true);
  }

  setCookie(cName, cValue, expDays) {
    let date = new Date();
    date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new Geolocator();
  new LocationBasedPopup();
})